import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import GetORPostAsync from '../constants/restservice';
import Swal from "sweetalert2";

export default function TicketHistory(props) {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    useEffect(() => {
        GetTransactions();
    }, [])

    const GetTransactions = async () => {
        let res = await GetORPostAsync("support_report.asp", "GET", null, localStorage.getItem("token"));
        if (res.status == "error") {
            if (res.message == "Session Expired") {
                navigate("/");
            }
            toast(res.message);
            return;
        }
        setData(res.items);
    }

    return (
        <div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Ticket History</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered  align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Subject</th>
                                            <th>Status</th>
                                            <th>Attachment</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data.length <= 0 ? <tr>
                                                <td colSpan="6" className='text-center'>No Details Found</td>
                                            </tr> :
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.create_date}</td>
                                                        <td>{item.category}</td>
                                                        <td>{item.status}</td>
                                                        <td>{item.attachmentURL ? <button className='badge btn-primary' onClick={(e) => {
                                                            Swal.fire({
                                                                title: "Attachment",
                                                                imageUrl: item.attachmentURL,
                                                                confirmButtonText: 'Close'
                                                            })
                                                        }}>View Attachment</button> : '-'}</td>
                                                        <td><button className='badge btn-success'><Link className='text-white' to={`/ticketreply/${item.supportid}`}  >View Replies</Link></button>
                                                            <button style={{ marginLeft: 10 }} className='badge btn-danger' onClick={(e) => {
                                                                Swal.fire({
                                                                    title: 'Reply',
                                                                    html: `<textarea type="text" id="login" class="form-control" placeholder="Enter your reply here"></textarea>`,
                                                                    confirmButtonText: 'Add reply',
                                                                    focusConfirm: false,
                                                                    background:'#262625',
                                                                    preConfirm: async () => {
                                                                        const login = Swal.getPopup().querySelector('#login').value
                                                                        if (!login) {
                                                                            Swal.showValidationMessage(`Please enter reply message`);
                                                                            return;
                                                                        }
                                                                        let response = await GetORPostAsync('support_reply.asp', 'POST', JSON.stringify({ supportid: item.supportid, reply: login }), localStorage.getItem('token'));
                                                                        if (response.status == 'error') {
                                                                            Swal.showValidationMessage(response.message);
                                                                        } else {
                                                                            toast(response.message);
                                                                            return true;
                                                                        }
                                                                    }
                                                                })
                                                            }}>Reply</button></td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}